export const API_BASE =
  (typeof window !== "undefined" && (window as any).__API_BASE__) ||
  process.env.REACT_APP_API_BASE ||
  "http://127.0.0.1:8002";



export const formatCTC = (val?: string | number | null): string => {
  if (!val) return "—";
  const n = Number(val);
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const toTitleCase = (str?: string): string =>
  str ? str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "—";



export const getResumeServeUrl = (
  documentId?: string | number,
): string | null =>
  documentId
    ? `${API_BASE}/api/recruitmentService/candidate/document/serve/${documentId}`
    : null;



const AVATAR_COLORS: [string, string][] = [
  ["#667eea", "#764ba2"],
  ["#f093fb", "#f5576c"],
  ["#4facfe", "#00f2fe"],
  ["#43e97b", "#38f9d7"],
  ["#fa709a", "#fee140"],
];

export const getGradient = (name = ""): string => {
  const [a, b] = AVATAR_COLORS[name.charCodeAt(0) % AVATAR_COLORS.length];
  return `linear-gradient(135deg,${a},${b})`;
};
